document.addEventListener('stripe:setup-add-card', () => {
  if ( $('#seller-add-card-element').data('pk') ) {
    const published_key = $('#seller-add-card-element').data('pk')
    const stripe = Stripe(published_key);

    var cardButton = document.getElementById('seller-add-card-button');
    var clientSecret = cardButton.dataset.secret;

    var elements = stripe.elements({ clientSecret: clientSecret });
    var paymentElement = elements.create('payment', {
      fields: { billingDetails: { name: 'always' } },
      wallets: { link: 'never' }
    });
    paymentElement.mount('#seller-add-card-element');

    cardButton.addEventListener('click', async function(ev) {
      ev.preventDefault();
      $('#stripe-error-message').slideUp();
      $('#stripe-error-message .alert').text('')
      $(cardButton).text('Submitting...');
      $(cardButton).prop('disabled', true);

      const submission = await elements.submit();
      if (submission.error) {
        $('#stripe-error-message .alert').text(submission.error.message)
        $('#stripe-error-message').slideDown();
        $(cardButton).text('Add Card');
        $(cardButton).prop('disabled', false);
        return;
      }

      const result = await stripe.confirmSetup({
        elements: elements,
        confirmParams: {
          return_url: cardButton.dataset.returnUrl
        },
        redirect: 'if_required'
      });

      if (result.error) {
        $('#stripe-error-message .alert').text(result.error.message)
        $('#stripe-error-message').slideDown();
        $(cardButton).text('Add Card');
        $(cardButton).prop('disabled', false);
      } else {
        $('#add-new-card').slideUp(400, () => {
          const confirmation = `
            <h3>Card Added</h3>
          `
          $('#add-new-card').html(confirmation);
          $('#add-new-card').slideDown();
        });
        // The new card is attached to the customer via an async
        // payment_method.attached webhook, so give it a moment to land
        // before reloading to show it in the Charge Cards table.
        setTimeout(() => { window.location.reload(); }, 2000);
      }
    });
  }
})
